import { format, startOfWeek, endOfWeek } from 'date-fns';

export const groupDataByTimeRange = (data, timeRange, dateField, valueField) => {
  if (!data || data.length === 0) return [];

  const grouped = {};

  const getGroupKey = (date, range) => {
    if (range === '7d') {
      return format(date, 'dd MMM'); // Group by day
    }
    if (range === '30d' || range === '90d') { 
      // Group by week
      const start = startOfWeek(date, { weekStartsOn: 1 });
      const end = endOfWeek(date, { weekStartsOn: 1 });
      const startDay = format(start, 'dd'); 
      const endDay = format(end, 'dd');
      const startMonth = format(start, 'MMM');
      const endMonth = format(end, 'MMM');

      if (startMonth !== endMonth) {
        return `${startDay} ${startMonth} - ${endDay} ${endMonth}`;
      }
      return `${startDay}-${endDay} ${startMonth}`;
    }
    // For 90d, 180d, and overall
    return format(date, 'MMM yyyy'); // Group by month
  };

  data.forEach(item => {
    const itemDate = new Date(item[dateField]);
    if (isNaN(itemDate.getTime())) {
      console.warn('Skipping item with invalid date:', item);
      return;
    }
    const key = getGroupKey(itemDate, timeRange);

    if (!grouped[key]) {
      grouped[key] = { label: key, total: 0, count: 0, date: itemDate };
    }
    grouped[key].total += item[valueField] || 0;
    grouped[key].count++;
  });

  const result = Object.values(grouped).map(g => ({
    label: g.label,
    average_value: g.count > 0 ? g.total / g.count : 0,
    total_value: g.total,
    date: g.date,
  }));
  
  result.sort((a, b) => a.date - b.date);
  return result.map(({ date, ...rest }) => rest);
}; 